import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
export default (function ($prop, ctx) {
  ctx.$on('popup:open', function () {
    var id_question = Utils.str2Num(ctx.$f7route.params.qid);
    var row = Base.faqItems.get(id_question);
    $('.question-content').html(row.content);
    $('.question-content').attr("contenteditable", true);

    var likeAnswer = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id_answer, like) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", Base.api('Faq', 'likeAnswer', {
                  id_answer: id_answer,
                  like: like
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function likeAnswer(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    var makeRow = function makeRow(item) {
      var id_answer = Utils.str2Num(item.id);
      var name = Utils.str2Num(item.show_name) === 0 ? Base.anonymousLabel : item.name;
      var totalLikes = 0;
      var likeButton = 'hand_thumbsup';

      try {
        if (item.who_likes !== null) {
          var likes = JSON.parse(item.who_likes);
          totalLikes = likes.length;
          likes.forEach(function (id) {
            if (Base.user.id === Utils.str2Num(id)) {
              likeButton = 'hand_thumbsup_fill';
              return false;
            }
          });
        }
      } catch (err) {}

      var $row = $("\n        <div class=\"block emp-answer\">\n          <div class=\"answer-content\">\n            <span class=\"author\" style=\"font-size:11px; color: white; border: 1px solid #ccc; padding: 2px; border-radius: 4px;\">".concat(name, "</span>\n            <span class=\"content\">").concat(item.content, "</span>\n          </div>\n          <div class=\"footer\" style=\"display: flex; flex-direction: row; justify-content: space-between; font-size: 12px;\">\n            <div class=\"likes\">\n              <span>").concat(totalLikes, "</span>\n              <a href=\"#\" class=\"button-like\"><i class=\"f7-icons icon\" style=\"font-size: 14px;\">").concat(likeButton, "</i></a>\n            </div>\n            <div class=\"datetime\">").concat(moment(item.created_date).format(Base.dateTimeFormat), "</div>\n          </div>\n        </div>\n      "));
      $row.find('.button-like').click(function (e) {
        var $div = $(e.target).closest('div');
        var $icon = $div.find('i');
        var $likeNumberWrapper = $div.find('span');
        var likeNum = Utils.str2Num($likeNumberWrapper.text());
        var likeLabel = $icon.text();
        var likeOrUnlike = 'like';
        console.log(likeNum, likeLabel);

        if (likeLabel === 'hand_thumbsup_fill') {
          //unlike
          likeLabel = 'hand_thumbsup';
          $icon.html(likeLabel);
          likeNum -= 1;
          likeOrUnlike = 'unlike';
        } else {
          //like
          likeLabel = 'hand_thumbsup_fill';
          $icon.html(likeLabel);
          likeNum += 1;
        }

        $likeNumberWrapper.text(likeNum);
        likeAnswer(id_answer, likeOrUnlike);
      });
      return $row;
    };

    var $listAnswer = $('.answers-list');

    var listAnswers = function listAnswers(rows) {
      if (rows.length === 0) return false;
      rows.forEach(function (item) {
        $listAnswer.append(makeRow(item));
      });
    };

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var rs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Base.api('Faq', 'getAnswers', {
                id_question: id_question
              });

            case 2:
              rs = _context2.sent;
              listAnswers(rs.rows);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();

    var saveAnswer = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var content, show_name, rs;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                content = $('textarea[name="emp_answer"]').val();
                show_name = $('input[name="show_name"]').prop('checked') ? 1 : null;
                _context3.next = 4;
                return Base.api('Faq', 'saveAnswer', {
                  content: content,
                  show_name: show_name,
                  id_question: id_question
                });

              case 4:
                rs = _context3.sent;
                $listAnswer.prepend(makeRow(rs.row));
                $('textarea[name="emp_answer"]').val('');
                $('input[name="show_name"]').prop('checked', false);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function saveAnswer() {
        return _ref3.apply(this, arguments);
      };
    }();

    $('.save-answer').click(function (e) {
      Base.app.dialog.confirm('Bạn chắc chắn với câu trả lời này chứ?', function () {
        saveAnswer();
      });
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup" data-name="faq-answer-popup">

    <div class="view">
      <div class="page">

        <div class="navbar">
          <div class="navbar-bg"></div>
          <div class="navbar-inner">
            <div class="title">Câu trả lời của bạn</div>
            <div class="right"><a href="#" class="link popup-close"><i class="icon f7-icons">multiply</i></a></div>
          </div>
        </div>
        <div class="page-content">
          <fieldset>
            <legend>Câu hỏi/Vấn đề của khách</legend>
            <div contenteditable="false" class="question-content"></div>
          </fieldset>
    
          <div class="block-title">
            <div class="row">
              <div class="col">Bạn sẽ trả lời như thế nào?</div>
              <div class="col text-align-right"><a class="link save-answer">Lưu lại</a></div>
            </div>
          </div>
          <div class="list no-hairlines no-margin">
            <ul>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-input-wrap">
                      <textarea name="emp_answer" id="" cols="30" rows="10" placeholder="" style="height: 50vw;"></textarea>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <label class="item-checkbox item-content">
                  <input type="checkbox" name="show_name" />
                  <i class="icon icon-checkbox"></i>
                  <div class="item-inner"><div class="item-title">Hiện tên người trả lời?</div></div>
                </label>
              </li>
            </ul>
          </div>
    
          <div class="block-title">Các câu trả lời khác</div>
          <div class="answers-list"></div>  
          
        </div>

      </div>
    </div>

  </div>
`
    }
    ;
});